import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Prices } from "./components/Prices";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import Timeplan from "./components/Timeplan";
import RegistrationForm from "./components/RegistrationForm";
import PageNotFound from "./components/PageNotFound";
import Workshops from "./components/Workshops";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <BrowserRouter>
        <div className="pages">
          <Routes>
            <Route
              path="/"
              element={
                <div>
                  <Navigation data={landingPageData.Nav} />
                  <Header data={landingPageData.Header} />
                  
                  <Features data={landingPageData.Features} />
                  <Workshops />
                  {/* <Timeplan /> */}
                  {/* <Prices data={landingPageData.Prices} /> */}
                  {/* <Gallery data={landingPageData.Gallery} /> */}
                  {/* <Testimonials data={landingPageData.Testimonials} /> */}
                  <Team data={landingPageData.Team} />

                  <About data={landingPageData.About} />

                  <Contact data={landingPageData.Contact} />
                </div>
              }
            />
            <Route
              path="/register"
              element={
                <div>
                  <RegistrationForm data={landingPageData.Nav} link={landingPageData.link}/>
                  <Contact data={landingPageData.Contact} />
                </div>
              }
            />
            <Route
              path="*"
              element={
                <PageNotFound data={landingPageData.Nav}/>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
